/**
 * Enum for table setting keys.
 * @readonly
 * @enum {string}
 */
const TableSettings = Object.freeze({
    CurrentPage: 'currentPage',
    PerPage: 'perPage',
    Search: 'search',
    Sort: 'sort',
    FormData: 'formData',
});

export default TableSettings;
